import { BlurFade } from '@/components/ui/blur-fade'
import { cn } from '@/lib/utils'
import { PillButton } from './PillButton'

const FACILITATORS_IMAGE = {
  alt: 'Facilitator setting up a studio, warm light',
  src: './home-page/4.jpg',
}

export function ForFacilitatorsSection() {
  return (
    <section className="bg-cream-50">
      <div className="mx-auto max-w-[1200px] px-6 py-16 lg:px-20 lg:py-20">
        <div className="grid items-center gap-12 lg:grid-cols-2">
          <BlurFade>
            <div>
              <h2 className="text-3xl font-bold leading-tight text-gray-900 sm:text-4xl">
                For facilitators, spaces, and communities doing meaningful work
              </h2>
              <p className="mt-6 text-lg leading-relaxed text-gray-700">
                Wellness Loop supports facilitators and wellness spaces with
                visibility, discovery, collaboration, and access to an aligned
                audience.
              </p>
              <p className="mt-4 text-lg leading-relaxed text-gray-700">
                We help bring your classes, workshops, retreats, and programs to
                people who are actively seeking practices that support their
                wellbeing.
              </p>
              <div className="mt-8 flex flex-col gap-3 sm:flex-row">
                <PillButton to="/facilitators/register" variant="primary">
                  List your offering
                </PillButton>
                <PillButton to="/for-facilitators" variant="secondary">
                  Partner with us
                </PillButton>
              </div>
            </div>
          </BlurFade>

          <BlurFade delay={0.15}>
            <img
              src={FACILITATORS_IMAGE.src}
              alt={FACILITATORS_IMAGE.alt}
              loading="lazy"
              decoding="async"
              className={cn(
                'h-[320px] w-full rounded-3xl object-cover shadow-lg lg:h-[400px]'
              )}
            />
          </BlurFade>
        </div>
      </div>
    </section>
  )
}
